module.exports = __webpack_public_path__ + "img/115.3d7a3169.jpg";